export default __webpack_public_path__ + "static/media/contentment-icon.a795efcb.svg";